<script setup>
import { computed } from 'vue';
import NavItem from '../NavItem/Index.vue';
import { Icon } from '@iconify/vue';
import { useTranslation } from '@/utils/locales/messages';
import { useLanguageStore } from '@/shared/stores/languageStore';
import { ChevronDownIcon } from 'vue-tabler-icons';

const props = defineProps({ item: Object, level: Number });

const languageStore = useLanguageStore();
const { createSyncT } = useTranslation();
const t = createSyncT(languageStore.currentLanguage);

// 언어 변경 시 자동으로 업데이트되도록 computed로 감싸기
const menuTitle = computed(() => {
  const translationKey = 'menu.' + props.item.title;
  const translated = t(translationKey);
  // 번역 키가 그대로 반환된 경우 (번역을 찾지 못한 경우) 원본 title 사용
  if (translated === translationKey || translated.startsWith('menu.')) {
    return props.item.title;
  }
  return translated || props.item.title;
});
</script>

<template>
    <!---Dropdown  -->
    <a class="navItemLink rounded-pill cursor-pointer navcollapse">
        <!---Icon  -->
        <i class="navIcon"><Icon :icon="'solar:' + item.icon" height="18" width="18" :level="level" class="dot" :class="'text-' + item.BgColor"/></i>
        <!---Title  -->
        <span class="mr-auto">{{ menuTitle }}</span>
        <!---If Caption-->
        <small v-if="item.subCaption" class="text-caption mt-n1 hide-menu">
            {{ item.subCaption }}
        </small>
        <i class="ddIcon ml-2 d-flex align-center"><ChevronDownIcon size="15" /></i>
    </a>
    <!---Sub Item-->
    <ul :class="`ddMenu ddLevel-${level + 1}`">
        <li v-for="(subitem, i) in item.children" :key="i" v-if="item.children" class="navItem">
            <Index :item="subitem" v-if="subitem.children" :level="level + 1" />
            <NavItem :item="subitem" :level="level + 1" v-else></NavItem>
        </li>
    </ul>
    <!---End Item Sub Header -->
</template>